import React from 'react';
import { getKycStatus } from '../constants/api';
import ComingSoon from 'react-coming-soon';
import SideBar from '../../containers/PartnerKyc/Sidebar/Sidebar';
import UpdatePassword from '../../components/UpdatePassword/UpdatePassword';
import Dashboard from '../../components/Dashboard/kyc';
import { getUserType } from '../../common/utils/cookie-utils';
import iconWhiteDash from '../../images/icons/iconWhiteDash.svg';
import iconBpPartner from '../../images/icons/iconBpPartner.svg';
import iconCommissions from '../../images/icons/iconCommissions.svg';
import iconInvoicing from '../../images/icons/iconInvoicing.svg';
import iconPerformance from '../../images/icons/IconPerformance.svg';
import iconFcu from '../../images/icons/iconFcu.svg';
import iconKyc from '../../images/icons/kyc.svg';
import Commissions from '../../containers/Commission/Commissions';

export const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const navItemsForkyc = () => {
  const temp = getUserType();
  return [
    ...(temp == 0
      ? [
          { icons: iconWhiteDash, link: '/app/dashboard', label: 'Dashboard' },
          {
            icons: iconCommissions,
            link: '/app/commissions',
            label: 'Commissions'
          },
          { icons: iconInvoicing, link: '/app/invoicing', label: 'Invoicing' },
          {
            icons: iconPerformance,
            link: '/',
            label: 'Performance',
            dropdown: [
              {
                icons: iconFcu,
                link: '/app/performance_report',
                label: 'Performance Reports'
              },
              {
                icons: iconFcu,
                link: '/app/report/bankperformance',
                label: 'Bank Performance'
              },
              {
                icons: iconFcu,
                link: '/app//business_targets',
                label: 'Business Targets'
              },
              {
                icons: iconFcu,
                link: '/app/call_details',
                label: 'Call Details'
              }
            ]
          },
          { icons: iconKyc, link: '/app/kyc', label: 'KYC' }
        ]
      : [
          { icons: iconWhiteDash, link: '/app/dashboard', label: 'Dashboard' },
          {
            icons: iconBpPartner,
            link: '/app/bp',
            label: 'Business Partner'
          },
          {
            icons: iconCommissions,
            link: '/app/commissions',
            label: 'Commissions'
          },
          { icons: iconInvoicing, link: '/app/invoicing', label: 'Invoicing' },

          {
            icons: iconPerformance,
            link: '/',
            label: 'Performance',
            dropdown: [
              {
                icons: iconFcu,
                link: '/app/performance_report',
                label: 'Performance Reports'
              },
              {
                icons: iconFcu,
                link: '/app/business_targets',
                label: 'Business Targets'
              },
              {
                icons: iconFcu,
                link: '/app/call_details',
                label: 'Call Details'
              }
            ]
          },
          { icons: iconFcu, link: '/app/fcu', label: 'FCU' },
          { icons: iconKyc, link: '/app/kyc', label: 'KYC' }
        ])
  ];
};

export const UserKycStatus = async () => {
  return getKycStatus().then(res => {
    var data = {
      pan: res[0].status,
      address: res[1].status,
      selfie: res[2].status,
      bank: res[3].status,
      ref: res[4].status,
      custom: false
    };
    return data;
  });
};
let obj = {
  isFirstLoadKYC: true
};
export { obj };
export const reactComingSoon = () => {
  obj.isFirstLoadKYC = true;
  return (
    <div className="-mt-17 md:m-0">
      <ComingSoon
        image="https://react-coming-soon.maksv.me/default-image.jpeg"
        bgColor="#fff"
        textColor="#000"
        illustration="development"
      />
    </div>
  );
};
export const Settings = () => {
  obj.isFirstLoadKYC = true;
  return <SideBar Component={UpdatePassword} />;
};
export const comingSoonPage = () => {
  obj.isFirstLoadKYC = true;
  return <SideBar Component={reactComingSoon} />;
};
export const commissions = () => {
  obj.isFirstLoadKYC = true;
  return <SideBar Component={Commissions} />;
};
export const RedirectToDashboard = () => {
  obj.isFirstLoadKYC = true;
  return <Dashboard />;
};
export const RedirectToPartnerProfilePage = () => {
  obj.isFirstLoadKYC = true;
  return <Dashboard />;
};
